import getHtmlParam from '../../utilities/htmlParam';

export class SimilarProducts {

  param = getHtmlParam('.js-param .param');

  init() {
    const container = document.getElementById('similar-products-container') as HTMLElement;
    if (container) {
      window.fetch(this.param.get('urlPrefix') + '/mapping/new/product-comparison?productId=' + container.dataset.similarproductid + '&categoryId=' + container.dataset.similarcategoryid + '&layout=se-similar-products&selectedItem=' + this.param.get('productId'))
        .then(res => res.text())
        .then((data) => {
          const el = document.createElement('div');
          el.innerHTML = data;
          const products = el.querySelectorAll('.similar-product');
          if (products.length < 3) return false;
          container.innerHTML = data;
          container.classList.add('loaded');
        }).catch(err => {
            console.log(err);
        });
    }
  }
}